import type { DestinationOption } from "../api/catalog";
import { SelectCountrySlot } from "./SelectCountrySlot";

export interface SelectDestinationCountrySlotProps {
  countries: DestinationOption[];
  selectedCountry?: string | null;
  selectedCurrency?: string | null;
  onSelect: (countryCode: string, currencyCode: string) => void;
  onClose: () => void;
}

export const SelectDestinationCountrySlot: React.FC<
  SelectDestinationCountrySlotProps
> = (props) => (
  <SelectCountrySlot titleKey="transfer.selectDestination" {...props} />
);
